import { Flex, Text } from "@chakra-ui/react";
import { StatusBox } from "@domains/components/statusBox";
import { StatusGroup } from "@shared/client";

export const ReservationStatusBox = () => {
    return (
        <Flex alignItems={"center"} justifyContent="center" columnGap="16px">
            {StatusGroup.map((status) => {
                return (
                    <Flex key={status.status} gap="8px" align={"center"}>
                        <StatusBox status={status.status} />
                        <Text fontWeight={"500"} fontSize="16px">
                            {status.title}
                        </Text>
                    </Flex>
                );
            })}
        </Flex>
    );
};
